import styled, { useTheme } from "styled-components";
import { IconCheckCircle, IconAlert } from "suomifi-icons";
import { useTranslation } from "react-i18next";

interface Props {
  todennettu: boolean;
}

interface TagProps {
  $bg: string;
  $fg: string;
}

// Kulmikas kevyt-värinen tag — sama tyyli kuin TilaBadge ja muut kaikkialla.
const Tag = styled.span<TagProps>`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xxs};
  padding: ${({ theme }) => theme.spacing.xxs} ${({ theme }) => theme.spacing.s};
  font: ${({ theme }) => theme.typography.actionElementInnerTextBold};
  font-size: 0.75rem;
  line-height: 1.4;
  background: ${({ $bg }) => $bg};
  color: ${({ $fg }) => $fg};
  white-space: nowrap;
  flex-shrink: 0;

  & > svg {
    width: 0.9375rem;
    height: 0.9375rem;
  }
`;

export default function HenkilollisyysBadge({ todennettu }: Props) {
  const theme = useTheme();
  const { t } = useTranslation("common");
  if (todennettu) {
    return (
      <Tag $bg={theme.colors.successSecondary} $fg={theme.colors.successDark1}>
        <IconCheckCircle aria-hidden />
        {t("henkilollisyys.todennettu")}
      </Tag>
    );
  }
  return (
    <Tag $bg={theme.colors.warningLight1} $fg={theme.colors.blackBase}>
      <IconAlert aria-hidden />
      {t("henkilollisyys.eiTodennettu")}
    </Tag>
  );
}
